/**
 * Guide index. Each entry maps to a page in src/pages/guides/<slug>.js.
 * Keep `updated` in ISO format; it feeds the Article schema and the listing.
 */
export const GUIDES = [
  {
    slug: "office-pod-planning-permission-uk",
    title: "Do you need planning permission for an office pod in the UK?",
    shortTitle: "Office pods and planning permission",
    excerpt:
      "What the rules say for a booth inside your office, a pod in the garden and a structure outside a commercial building, and when it is worth asking a planning professional.",
    updated: "2026-09-24",
    readingTime: "8 min read",
  },
  {
    slug: "how-much-sound-insulation-does-a-phone-booth-need",
    title: "How much sound insulation does a phone booth need?",
    shortTitle: "Understanding booth sound insulation",
    excerpt:
      "Decibels, speech level reduction and the ISO 23351 classes explained in plain English, so you can compare booths on the number that matters.",
    updated: "2026-09-24",
    readingTime: "6 min read",
  },
  {
    slug: "phone-booth-or-meeting-pod",
    title: "Phone booth or meeting pod? Sizing quiet space for your team",
    shortTitle: "Phone booth or meeting pod",
    excerpt:
      "How many booths an open-plan office needs, where to put them, and how to check ceiling height, power and ventilation before you order.",
    updated: "2026-09-24",
    readingTime: "6 min read",
  },
]

export const findGuide = (slug) => GUIDES.find((g) => g.slug === slug)
